import { Bar, BarChart, CartesianGrid, LabelList, Tooltip, XAxis, YAxis } from "recharts";
import { formatCompactCurrency, formatCurrency } from "@/lib/calculators";
import { EXPANSION_MRR } from "./exampleData";
import {
  BORDER,
  CHART_POSITIVE_MUTED,
  MUTED_FG,
  tooltipStyle,
  xAxisProps,
  yAxisProps,
} from "./chartTheme";
import MetricChartFrame from "./MetricChartFrame";

/**
 * Expansion MRR by month — the additional recurring revenue from existing
 * customers upgrading, adding seats or buying add-ons. A steady climb to the
 * running example's $3,000 expansion month, shown in the product's widget style.
 */
const ExpansionMrrChart = () => (
  <MetricChartFrame
    caption="Expansion MRR is lumpy month to month — a big upgrade one month, a quiet one the next — but trends up to $3,000 as existing customers add seats and buy add-ons, growth that carries no new acquisition cost."
    breakdown="No breakdown"
    active="6M"
  >
    <BarChart data={EXPANSION_MRR} margin={{ top: 16, right: 8, left: 8, bottom: 0 }}>
      <CartesianGrid strokeDasharray="3 3" stroke={BORDER} vertical={false} />
      <XAxis dataKey="label" {...xAxisProps} />
      <YAxis tickFormatter={(v) => formatCompactCurrency(Number(v))} width={52} {...yAxisProps} />
      <Tooltip
        cursor={{ fill: "hsl(var(--muted) / 0.4)" }}
        contentStyle={tooltipStyle}
        formatter={(value: number) => [formatCurrency(value), "Expansion MRR"]}
      />
      <Bar
        dataKey="value"
        fill={CHART_POSITIVE_MUTED}
        radius={[4, 4, 0, 0]}
        isAnimationActive={false}
      >
        <LabelList
          dataKey="value"
          position="top"
          formatter={(v: number) => formatCompactCurrency(Number(v))}
          fontSize={11}
          fill={MUTED_FG}
        />
      </Bar>
    </BarChart>
  </MetricChartFrame>
);

export default ExpansionMrrChart;
